import { render, staticRenderFns } from "./SMKExchangeRate.vue?vue&type=template&id=6a93d987&scoped=true&"
import script from "./SMKExchangeRate.vue?vue&type=script&lang=js&"
export * from "./SMKExchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./SMKExchangeRate.vue?vue&type=style&index=0&id=6a93d987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a93d987",
  null
  
)

export default component.exports